import otel, { ValueType } from '@opentelemetry/api'

import { APP_NAME } from '../config/costants'
import { MetricsAPI } from './types'

/**
 * The function `initializeMetricsAPI` initializes a MetricsAPI object with a `pushMetric` method that
 * records a histogram metric with specific attributes.
 * @returns An object with a `pushMetric` function is being returned.
 */
export function initializeMetricsAPI(): MetricsAPI {
  /**
   * The function `pushMetric` records a histogram metric for rule engine performance with specified
   * attributes.
   * @param  - The `pushMetric` function takes an object with `value` and `attributes` properties as its
   * parameter. The `value` represents the metric value to be recorded, while `attributes` is an object
   * containing additional information related to the metric.
   * @returns If the `value` or `attributes` parameters are `undefined`, the function will return early
   * and not execute the rest of the code block.
   */
  const pushMetric: MetricsAPI['pushMetric'] = ({ value, attributes }) => {
    if (value === undefined || attributes === undefined) {
      return
    }
    const m = otel.metrics.getMeter(APP_NAME)

    const histogram = m.createHistogram('rule_engine.duration', {
      description: 'Rule engine performance',
      unit: 'milliseconds',
      valueType: ValueType.INT,
    })
    histogram.record(value, {
      fn: attributes.formName,
      en: attributes.entityName,
      unit: 'milliseconds',
      valueType: ValueType.INT,
    })
  }

  return {
    pushMetric,
  }
}
